import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-on-page',
  templateUrl: './on-page.component.html',
  styleUrls: ['./on-page.component.css'],
})
export class OnPageComponent implements OnInit {
  url: string = 'seoOffpageCampaigns';

  loading: boolean = true;
  saving: boolean = false;

  modalTitle: string = '';
  modalContent: string | null = null;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  // ── Filter state ──────────────────────────────────────────────────────────
  selectedLocation: string = 'all'; // default location
  selectedUniverse: string = 'courier'; // default universe
  selectedCategory: string = ''; // empty = all categories

  pendingLocation: string = 'all';
  pendingUniverse: string = 'courier';
  pendingCategory: string = '';

  // Unique values extracted from the loaded campaigns
  uniqueLocations: string[] = [];
  uniqueUniverses: string[] = [];
  uniqueCategories: string[] = [];

  // ── Lookup tables ─────────────────────────────────────────────────────────
  locations = [
    { value: 'all', label: 'All Locations' },
    { value: 'orlando_fl', label: 'Orlando, FL' },
    { value: 'tampa_fl', label: 'Tampa, FL' },
    { value: 'naples_fl', label: 'Naples, FL' },
    { value: 'west_palm_beach_fl', label: 'West Palm Beach, FL' },
    { value: 'boca_raton_fl', label: 'Boca Raton, FL' },
    { value: 'miami_fl', label: 'Miami, FL' },
  ];

  universes = [
    { value: 'courier', label: 'Courier' },
    { value: 'runner', label: 'Runner' },
  ];

  categories = [
    { value: 'company_brand', label: 'Company Brand' },
    { value: 'same_day_courier', label: 'Same-Day Courier' },
    { value: 'rush_courier', label: 'Rush Courier' },
    { value: 'scheduled_courier', label: 'Scheduled Courier' },
    { value: 'vip_courier', label: 'VIP Courier' },
    { value: 'concierge_courier', label: 'Concierge Courier' },
    { value: 'business_courier', label: 'Business Courier' },
    { value: 'legal_services', label: 'Legal Services' },
    { value: 'long_distance_courier', label: 'Long Distance Courier' },
    { value: 'last_mile_services', label: 'Last Mile Services' },
    { value: 'local_courier_services', label: 'Local Courier Services' },
  ];

  keywordIntents = [
    { value: 'high_intent_local', label: 'High-Intent Local' },
    { value: 'broad_commercial', label: 'Broad Commercial' },
    { value: 'mixed_high_intent', label: 'Mixed High-Intent' },
    { value: 'informational', label: 'Informational' },
    { value: 'navigational', label: 'Navigational' },
    { value: 'brand_intent', label: 'Brand Intent' },
  ];

  // ── Loaded data ───────────────────────────────────────────────────────────
  /** All approved campaigns fetched from the API */
  allCampaigns: any[] = [];

  /** Currently selected (active) campaign after filter match */
  campaign: any = null;

  /** Active campaign _id – used when saving keyword changes */
  campaignId: string = '';

  // ── Derived view data ─────────────────────────────────────────────────────
  stats = {
    urlsReviewed: { value: 0, trend: '', up: true },
    needsOptimization: { value: 0, trend: '', up: true },
    readyToMap: { value: 0, trend: '', up: false },
    mappingGaps: { value: 0, trend: '', up: false },
    contentNeeds: { value: 0, text: '' },
  };

  reviewsQueue: any[] = [];

  // Selected item for right-side panel
  selectedMapping: any = {
    keyword: '',
    status: '',
    tags: [],
    primaryUrlCandidate: '',
    architecturalFit: '',
    semanticCoverage: '',
    explicitIntentSupport: '',
    cannibalizationRisk: '',
    technicalEligibility: '',
    contentDepth: '',
    currentRankingUrl: '',
    mappingDivergence: '',
    aiRationale: '',
    _index: -1,
  };

  // Decision center form state
  decisionUrl: string = '';
  decisionNote: string = '';

  // ── Static UI-only widgets ────────────────────────────────────────────────
  recommendedActions = [
    {
      action: 'Strengthen Page Title',
      type: 'Title',
      impact: 'High',
      confidence: '94%',
      status: 'Proposed',
    },
    {
      action: 'Improve H1 Specificity',
      type: 'H1',
      impact: 'High',
      confidence: '88%',
      status: 'Proposed',
    },
    {
      action: 'Add Courthouse Delivery Section',
      type: 'Content',
      impact: 'High',
      confidence: '91%',
      status: 'Content Need',
    },
    {
      action: 'Add FAQ Block',
      type: 'FAQ',
      impact: 'Medium',
      confidence: '87%',
      status: 'Content Need',
    },
    {
      action: 'Strengthen Booking CTA',
      type: 'CTA',
      impact: 'Medium',
      confidence: '86%',
      status: 'Proposed',
    },
  ];

  contentNeedsList = [
    {
      need: 'Section Needed',
      details: 'Add courthouse delivery process and capabilities',
      priority: 'High',
      action: 'Create Production Need',
    },
    {
      need: 'FAQ Needed',
      details: 'Common questions about legal courier & court filing',
      priority: 'Medium',
      action: 'Create Production Need',
    },
  ];

  signalsSentList = [
    {
      signal: 'Mapping Review Recommended',
      to: 'URL Mapping',
      status: 'Sent',
      date: 'May 18',
    },
    {
      signal: 'Internal Support Needed',
      to: 'Internal Links',
      status: 'Open',
      date: 'May 18',
    },
    {
      signal: 'On-Page Change Implemented',
      to: 'Performance',
      status: 'Monitoring',
      date: 'May 18',
    },
  ];

  signals = [
    {
      title: 'Explicit Intent Support Weak',
      to: 'ON-PAGE',
      status: 'Sent',
      date: 'May 18',
    },
    {
      title: 'Primary URL Needs Internal Support',
      to: 'INTERNAL LINKS',
      status: 'Sent',
      date: 'May 18',
    },
    {
      title: 'Technical Eligibility Review',
      to: 'TECHNICAL QA',
      status: 'Open',
      date: 'May 18',
    },
  ];

  recentActivity = [
    {
      action: 'Meta Description Updated',
      details: '/same-day-courier/',
      by: 'AI',
      date: 'May 18',
    },
    {
      action: 'Page Review Completed',
      details: '/cities/miami/',
      by: 'Felipe',
      date: 'May 18',
    },
    {
      action: 'Content Need Created',
      details: 'FAQ for /legal-services/',
      by: 'Felipe',
      date: 'May 17',
    },
    {
      action: 'Title Updated',
      details: '/task-runner/',
      by: 'AI',
      date: 'May 17',
    },
  ];

  constructor(
    private router: Router,
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  // ── Lifecycle ─────────────────────────────────────────────────────────────
  ngOnInit(): void {
    this.loadCampaigns();
  }

  // ── Data loading ──────────────────────────────────────────────────────────
  /**
   * Fetches ALL approved campaigns (no id in url).
   * After loading, derives unique filter values and auto-selects
   * the first campaign that matches the default location/universe.
   */
  loadCampaigns(): void {
    this.loading = true;

    // Build query params: only approved, no page limit needed for filtering
    const params = `?status=approved&limit=200`;

    this.dataService.getData(`${this.url}${params}`).subscribe(
      (response: any) => {
        if (response.rst && response.data) {
          this.allCampaigns = response.data;
          this.extractUniqueFilterValues();
          this.applyFilterAndSelect();
        } else {
          this.messageService.add(
            response.msg || 'Error loading campaigns',
            'danger',
          );
          this.loading = false;
        }
      },
      (_err: any) => {
        this.messageService.add('Could not connect to the server.', 'danger');
        this.loading = false;
      },
    );
  }

  /** Pull distinct location / universe / category values from all loaded campaigns */
  extractUniqueFilterValues(): void {
    const locSet = new Set<string>();
    const uniSet = new Set<string>();
    const catSet = new Set<string>();

    this.allCampaigns.forEach((c: any) => {
      if (c.location) locSet.add(c.location);
      if (c.universe) uniSet.add(c.universe);
      if (c.category) catSet.add(c.category);
    });

    this.uniqueLocations = Array.from(locSet).sort();
    this.uniqueUniverses = Array.from(uniSet).sort();
    this.uniqueCategories = Array.from(catSet).sort();

    // If default selectedLocation is not present in data, fall back to first available
    if (
      this.uniqueLocations.length &&
      !this.uniqueLocations.includes(this.selectedLocation)
    ) {
      this.selectedLocation = this.uniqueLocations[0];
      this.pendingLocation = this.selectedLocation;
    }
    if (
      this.uniqueUniverses.length &&
      !this.uniqueUniverses.includes(this.selectedUniverse)
    ) {
      this.selectedUniverse = this.uniqueUniverses[0];
      this.pendingUniverse = this.selectedUniverse;
    }
  }

  /**
   * Filters allCampaigns by the active filter selections and
   * picks the first matching campaign to display its keyword mappings.
   */
  applyFilterAndSelect(): void {
    const matched = this.allCampaigns.filter((c: any) => {
      const locMatch =
        !this.selectedLocation || c.location === this.selectedLocation;
      const uniMatch =
        !this.selectedUniverse || c.universe === this.selectedUniverse;
      const catMatch =
        !this.selectedCategory || c.category === this.selectedCategory;
      return locMatch && uniMatch && catMatch;
    });

    if (matched.length === 0) {
      this.campaign = null;
      this.campaignId = '';
      this.reviewsQueue = [];
      this.resetStats();
      this.loading = false;
      return;
    }

    // Use the first matched campaign (best-fit)
    this.campaign = matched[0];
    this.campaignId = matched[0]._id;
    this.buildReviewsQueue();
    this.buildStats();
    this.loading = false;
  }

  /** Called whenever a filter dropdown changes */
  onFilterChange(): void {
    this.selectedLocation = this.pendingLocation;
    this.selectedUniverse = this.pendingUniverse;
    this.selectedCategory = this.pendingCategory;

    this.selectedMapping = { ...this.selectedMapping, _index: -1 };
    this.applyFilterAndSelect();
  }

  // ── Mappings builder ──────────────────────────────────────────────────────
  buildReviewsQueue(): void {
    this.reviewsQueue = [
      {
        url: '/legal-services/',
        mappedIntent: 'Miami Legal Courier',
        titleAlignment: 'Weak',
        h1Alignment: 'Weak',
        contentDepth: 'Moderate',
        ctaAlignment: 'Weak',
        faqOpportunity: 'Yes',
        status: 'Needs Work',
        recommendedAction: 'Strengthen Title & H1',
      },
      {
        url: '/same-day-courier/',
        mappedIntent: 'Same-Day Courier Miami',
        titleAlignment: 'Good',
        h1Alignment: 'Good',
        contentDepth: 'Strong',
        ctaAlignment: 'Good',
        faqOpportunity: 'No',
        status: 'Ready',
        recommendedAction: 'Maintain',
      },
      {
        url: '/cities/miami/',
        mappedIntent: 'Courier in Miami',
        titleAlignment: 'Good',
        h1Alignment: 'Good',
        contentDepth: 'Strong',
        ctaAlignment: 'Good',
        faqOpportunity: 'Yes',
        status: 'Review',
        recommendedAction: 'Add FAQ Block',
      },
      {
        url: '/courthouse-delivery/',
        mappedIntent: 'Courthouse Delivery',
        titleAlignment: 'Weak',
        h1Alignment: 'Weak',
        contentDepth: 'Weak',
        ctaAlignment: 'Weak',
        faqOpportunity: 'Yes',
        status: 'Critical Gap',
        recommendedAction: 'Add Courthouse Section',
      },
      {
        url: '/medical-courier/',
        mappedIntent: 'Medical Courier',
        titleAlignment: 'Good',
        h1Alignment: 'Moderate',
        contentDepth: 'Moderate',
        ctaAlignment: 'Moderate',
        faqOpportunity: 'Yes',
        status: 'Needs Work',
        recommendedAction: 'Strengthen Content',
      },
      {
        url: '/routes/miami-to-orlando/',
        mappedIntent: 'Miami to Orlando Courier',
        titleAlignment: 'Weak',
        h1Alignment: 'Weak',
        contentDepth: 'Weak',
        ctaAlignment: 'Weak',
        faqOpportunity: 'No',
        status: 'Critical Gap',
        recommendedAction: 'Create Route Content',
      },
      {
        url: '/task-runner/',
        mappedIntent: 'Task Runner Services',
        titleAlignment: 'Good',
        h1Alignment: 'Good',
        contentDepth: 'Moderate',
        ctaAlignment: 'Good',
        faqOpportunity: 'No',
        status: 'Review',
        recommendedAction: 'Improve CTA',
      },
      {
        url: '/business-accounts/',
        mappedIntent: 'Business Accounts',
        titleAlignment: 'Good',
        h1Alignment: 'Good',
        contentDepth: 'Strong',
        ctaAlignment: 'Good',
        faqOpportunity: 'Yes',
        status: 'Ready',
        recommendedAction: 'Maintain',
      },
    ];

    this.selectMapping(this.reviewsQueue[0]);
  }

  buildStats(): void {
    this.stats = {
      urlsReviewed: { value: 186, trend: '18.4% vs last 30 days', up: true },
      needsOptimization: { value: 64, trend: '6.7% vs last 30 days', up: true },
      readyToMap: { value: 86, trend: '11.3% vs last 30 days', up: true },
      mappingGaps: { value: 16, trend: '5.9% vs last 30 days', up: false },
      contentNeeds: { value: 22, text: 'Need production' },
    };
  }

  resetStats(): void {
    this.stats = {
      urlsReviewed: { value: 0, trend: '', up: false },
      needsOptimization: { value: 0, trend: '', up: false },
      readyToMap: { value: 0, trend: '', up: false },
      mappingGaps: { value: 0, trend: '', up: false },
      contentNeeds: { value: 0, text: '' },
    };
  }

  // ── Selection & Decision Center ───────────────────────────────────────────
  selectMapping(m: any): void {
    this.selectedMapping = {
      // For main sidebar display
      keyword: m.url || '/legal-services/',
      status: m.status || 'Needs Work',
      tags: ['Primary URL'],
      primaryUrlCandidate: m.mappedIntent || 'Miami Legal Courier',

      // Ratings
      architecturalFit: m.titleAlignment || 'Weak', // mapped to Intent Prominence
      semanticCoverage: m.contentDepth || 'Moderate', // mapped to Semantic Coverage
      explicitIntentSupport: m.h1Alignment || 'Weak', // mapped to Title Alignment
      cannibalizationRisk: 'Moderate', // Meta Description
      technicalEligibility: 'Weak', // H1 Alignment
      contentDepth: 'Courthouse support, process steps', // Content gaps
      currentRankingUrl: 'Weak', // CTA alignment
      mappingDivergence: 'Yes - 6 recommended', // FAQ opp

      aiRationale:
        'The page covers legal services but does not clearly express Miami legal courier intent. Courthouse delivery support is missing and the CTA is not prominent enough to drive conversions.',
      _index: m.index || 0,
    };
    this.decisionUrl = 'Legal Courier Services in Miami | Courier & Beyond';
    this.decisionNote = '';
  }

  approveMapping(): void {
    if (this.selectedMapping._index < 0 || !this.campaignId) return;

    const keywords = JSON.parse(JSON.stringify(this.campaign?.keywords || []));
    if (!keywords[this.selectedMapping._index]) return;

    keywords[this.selectedMapping._index].url = this.decisionUrl.trim();
    keywords[this.selectedMapping._index].status = 'active';

    this.saving = true;
    this.dataService
      .putData(`${this.url}/edit/${this.campaignId}`, { keywords })
      .subscribe(
        (response: any) => {
          this.saving = false;
          if (response.rst) {
            this.campaign.keywords = keywords;
            this.messageService.add('Mapping approved and saved.', 'success');
            this.buildReviewsQueue();
            this.buildStats();
          } else {
            this.messageService.add(
              response.msg || 'Error saving mapping',
              'danger',
            );
          }
        },
        (_err: any) => {
          this.saving = false;
          this.messageService.add('Server error while saving.', 'danger');
        },
      );
  }

  rejectMapping(): void {
    if (this.selectedMapping._index < 0 || !this.campaignId) return;

    const keywords = JSON.parse(JSON.stringify(this.campaign?.keywords || []));
    if (!keywords[this.selectedMapping._index]) return;

    keywords[this.selectedMapping._index].url = '';
    keywords[this.selectedMapping._index].status = 'paused';

    this.saving = true;
    this.dataService
      .putData(`${this.url}/edit/${this.campaignId}`, { keywords })
      .subscribe(
        (response: any) => {
          this.saving = false;
          if (response.rst) {
            this.campaign.keywords = keywords;
            this.messageService.add('Mapping rejected.', 'info');
            this.buildReviewsQueue();
            this.buildStats();
          } else {
            this.messageService.add(
              response.msg || 'Error rejecting mapping',
              'danger',
            );
          }
        },
        (_err: any) => {
          this.saving = false;
          this.messageService.add('Server error while saving.', 'danger');
        },
      );
  }

  // ── Computed getters ──────────────────────────────────────────────────────
  get mappedCount(): number {
    return this.reviewsQueue.filter((m) => m.mappingStatus === 'Mapped').length;
  }

  get unmappedCount(): number {
    return this.reviewsQueue.filter((m) => m.mappingStatus === 'Unmapped')
      .length;
  }

  get needsReviewCount(): number {
    return this.reviewsQueue.filter((m) => m.mappingStatus === 'Needs Review')
      .length;
  }

  // ── Label helpers ─────────────────────────────────────────────────────────
  getIntentLabel(value: string): string {
    return this.keywordIntents.find((k) => k.value === value)?.label || value;
  }

  getLocationLabel(value: string): string {
    return this.locations.find((l) => l.value === value)?.label || value;
  }

  getUniverseLabel(value: string): string {
    return this.universes.find((u) => u.value === value)?.label || value;
  }

  getCategoryLabel(value: string): string {
    return this.categories.find((c) => c.value === value)?.label || value;
  }

  showModal(title: string, content: string) {
    this.modalTitle = title;
    this.modalContent = content;
  }

  closeModal() {
    this.modalContent = null;
  }

  goBack(): void {
    this.router.navigateByUrl('marketing');
  }
}

